import Vue, {VNode} from "vue";
import axiosInstance from "@/utils/axiosInstance";

const defaultPictures = {
  // users
  "user": require("@/assets/images/defaults/user.png"),
  "user-without-circle": require("@/assets/images/defaults/user-without-circle.png"),
  "user-group": require("@/assets/images/defaults/user-group.png"),
  // objects
  "key": require("@/assets/images/defaults/key.png"),
  "tool": require("@/assets/images/defaults/tool.png"),
  "letter": require("@/assets/images/defaults/letter.png"),
  "parcel": require("@/assets/images/defaults/parcel.png"),
  "gem": require("@/assets/images/defaults/gem.png"),
  "building": require("@/assets/images/defaults/building.png"),
  "other": require("@/assets/images/defaults/other.png"),
  "door_controller_urmet": require("@/assets/images/defaults/door_controller_urmet.png"),
  "door_controller_masterlock": require("@/assets/images/defaults/door_controller_masterlock.png"),
};
const loadingGif = require("@/assets/images/loading.gif");
const notFoundPicture = require("@/assets/images/not-found.png");

const isPublicImageUrl = (v?: string): boolean => {
  if (!v) { return false; }
  try {
    const url: URL = new URL(v);
    return url.protocol === "https:";
  } catch {
    return false;
  }
};

// https://stackoverflow.com/questions/40655333/vue-js-emit-event-from-directive

const applySrc = (value, el, binding) => {
  if (el.nodeName === "IMG") {
    if (isPublicImageUrl(value)) {
      el.referrerPolicy = "no-referrer";
    }
    el.src = value;
  } else if (binding.value.callback) {
    binding.value.callback(value);
  }
};

const updateSrcFn = (el: HTMLImageElement & { src?: string|null, defaultImg?: string }, binding, vnode) => {
  // default value
  if (typeof binding.value === "string") {
    binding.value = {
      src: binding.value,
    };
  }
  if (!binding.value.size) {
    binding.value.size = 256;
  }
  // loading
  if (binding.value.src === undefined) {
    applySrc(loadingGif, el, binding);
  }
  // no picture
  if (binding.value.src === null) {
    const defaultParam: string | undefined = binding.value.defaultImg?.toLowerCase();
    const defaultImg: string = defaultParam || "other";
    if (!defaultImg.includes("user")) {
      // For default images other than users, we're using icons, so we can apply this style
      el.style.borderRadius = "unset";
    }
    applySrc(defaultPictures[defaultImg], el, binding);
  }
  // picture
  if (binding.value.src) {
    if (isPublicImageUrl(binding.value.src)) {
      // Online picture
      applySrc(binding.value.src, el, binding);
    } else {
      // Myloby picture
      // important : only if value is modified
      if (!binding.oldValue || binding.oldValue.src !== binding.value.src) {
        const url = `${binding.value.src}?size=${binding.value.size}`;
        axiosInstance.get(url)
          .then(async (data) => {
            // success
            applySrc(data.data, el, binding);
            if (binding.value.callback) {
              vnode.context.$emit("myupdate", {});
            }
          })
          .catch(async (err) => {
            // error
            applySrc(notFoundPicture, el, binding);
          });
      } else {
        // no update need
      }
    }
  }
};

Vue.directive("mySrc", {
  bind(el: HTMLImageElement & { src?: string|null, defaultImg?: string }, binding, vnode) {
    updateSrcFn(el, binding, vnode);
  },
  update(el: HTMLImageElement & { src?: string|null, defaultImg?: string }, binding, vnode) {
    updateSrcFn(el, binding, vnode);
  },
});

const updateHrefFn = (el: HTMLElement & { href: string }, binding, vnode) => {
  if (binding.value) {
    if (binding.oldValue !== binding.value) {
      const url = binding.value;
      axiosInstance.get(url)
        .then((data) => {
          el.href = data.data;
        });
    }
  }
};

Vue.directive("myHref", {
  bind(el: HTMLElement & { href: string }, binding, vnode) {
    updateHrefFn(el, binding, vnode);
  },
  update(el: HTMLElement & { href: string }, binding, vnode) {
    updateHrefFn(el, binding, vnode);
  },
});
